import React, { useEffect, useState } from "react";
import { ShieldCheck, Star, Zap } from "lucide-react";
import { ridesApi } from "../../lib/api";

const TONE = {
  good: { bg: "bg-green-100", ring: "ring-green-200", text: "text-green-700", label: "On time" },
  watch: { bg: "bg-amber-100", ring: "ring-amber-200", text: "text-amber-800", label: "Keep an eye on it" },
  risk: { bg: "bg-red-100", ring: "ring-red-200", text: "text-red-700", label: "Needs improvement" },
  new: { bg: "bg-surface-200", ring: "ring-surface-300", text: "text-ink-soft", label: "New rider" },
};

export const ReliabilityCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { ridesApi.riderReliability().then(setD).catch(() => setD(null)); }, []);
  if (!d) return null;
  const tone = TONE[d.label] || TONE.new;
  const isNew = d.label === "new";
  const left = Math.max(0, 3 - (d.completed || 0));
  return (
    <div className="rounded-2xl border border-surface-300 bg-white p-5" data-testid="rider-reliability-card">
      <div className="flex items-center gap-4">
        <div className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-full ring-4 ${tone.bg} ${tone.ring}`}>
          <span className={`text-lg font-black ${tone.text}`} data-testid="reliability-score">{isNew ? "—" : `${d.score}%`}</span>
        </div>
        <div className="min-w-0">
          <h3 className="inline-flex items-center gap-2 text-base font-bold text-ink"><ShieldCheck className="h-4 w-4 text-brand" /> Your on-time score</h3>
          <p className={`mt-0.5 flex flex-wrap items-center gap-2 text-sm font-bold ${tone.text}`} data-testid="reliability-label">
            {isNew ? "New rider" : tone.label}
            {d.trusted && <span className="inline-flex items-center gap-1 rounded-full bg-green-600 px-2 py-0.5 text-[11px] font-bold text-white" data-testid="trusted-badge"><Star className="h-3 w-3" /> Trusted rider</span>}
          </p>
          <p className="mt-1 text-xs text-ink-soft" data-testid="reliability-help">
            {isNew
              ? `Complete ${left} more ${left === 1 ? "trip" : "trips"} to unlock your score. Drivers see this before accepting.`
              : `Based on ${d.completed} completed ${d.completed === 1 ? "trip" : "trips"}${d.no_shows > 0 ? ` and ${d.no_shows} no-show${d.no_shows === 1 ? "" : "s"}` : ""}. Arrive on time at pickup to keep it green.`}
          </p>
          {d.trusted && (
            <p className="mt-2 inline-flex items-center gap-1.5 rounded-xl bg-green-50 px-3 py-1.5 text-xs font-semibold text-green-700" data-testid="trusted-perk">
              <Zap className="h-3.5 w-3.5" /> Priority pickup — your ride reaches nearby drivers faster.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReliabilityCard;
